exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.moderation-tools-popover{height:100%\n}\n.moderation-tools-popover .trigger{display:flex !important;height:100%\n}\n.moderation-tools-button svg,.moderation-tools-button i{font-size:.8em\n}", ""]);

// exports
